import { Button } from '../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { ListFilterModal } from '../../../../../core/components/organism/ListFilterModal';
import { useRecordedClassesTab } from '../../../hooks/AprovaLive/useSavedClassesTab';
import { PastEventsListLoading } from '../../PastEventsListLoading';
import { RecordedClassesList } from '../RecordedClassesList';

interface RecordedClassesTabProps {
  origin?: 'challenge' | 'live';
}

function RecordedClassesTab({ origin = 'live' }: RecordedClassesTabProps) {
  const {
    recordedClasses,
    filteredRecordedClasses,
    total,
    filters,
    isModalFilterOpen,
    setIsModalFilterOpen,
    selectedFilters,
    setSelectedFilters,
    isLoadingList,
    isLoadingNextPage,
    fetchNextPage,
    handleMarkAsDone,
  } = useRecordedClassesTab(origin);

  const itemsCountLabel = total === 1
    ? '1 aula gravada'
    : `${total} aulas gravadas`;

  return (
    <div className='flex flex-col gap-lg'>
      <header className='mt-8 flex flex-col gap-xxl'>
      <Typography>As gravações ficarão disponíveis por tempo indeterminado.</Typography>
        <div className='flex flex-row items-center justify-between gap-8'>
          <Typography>{itemsCountLabel}</Typography>

          <Button
            variant='text'
            LeftIcon={'filter_list'}
            onClick={() => {
              setIsModalFilterOpen(true);
            }}
            className='md:mt-auto'
          >
            Filtrar aulas
          </Button>
        </div>
      </header>

      {isLoadingList ? (
        <PastEventsListLoading itensCount={5} />
      ) : (
        <RecordedClassesList
          items={filteredRecordedClasses}
          origin={origin}
          showLoadMoreButton={total > recordedClasses.length}
          onClickLoadMore={fetchNextPage}
          isLoadingMore={isLoadingNextPage}
          onDone={handleMarkAsDone}
        />
      )}

      <ListFilterModal
        title='Filtrar aulas gravadas'
        subtitle='Aprovalive'
        filters={filters}
        isOpen={isModalFilterOpen}
        onClose={() => {
          setIsModalFilterOpen(false);
        }}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
    </div>
  );
}

export { RecordedClassesTab };
